import { z } from "zod";

import UserRefByIdSchema from "@/areas/directory/schemas/UserRefByIdSchema";

const UpdateSubscriberSubscriptionSchema = z
  .object({
    roleId: z.string().uuid({ message: "Role is required." }),
    type: z.enum(["accountable", "responsible", "consulted", "informed", "coordinator"]),
    isNotificationEnabled: z.boolean(),
  })
  .passthrough();

const UpdateSubscriberSchema = z
  .object({
    user: UserRefByIdSchema,
    subscriptions: z.array(UpdateSubscriberSubscriptionSchema).superRefine((data, ctx) => {
      // if (data.filter((s) => s.type === "coordinator").length > 1) {
      //   ctx.addIssue({
      //     code: z.ZodIssueCode.custom,
      //     message: "Only one role with coordinator subscription type can be added.",
      //   });
      // }
      // if (data.filter((s) => s.type === "accountable").length > 1) {
      //   ctx.addIssue({
      //     code: z.ZodIssueCode.custom,
      //     message: "Only one role with accountable subscription type can be added.",
      //   });
      // }
    }),
  })
  .strict();

export default UpdateSubscriberSchema;
